export enum GoalSectionType {
    MyGoals = 1,
    PriorityCompleted = 2,
    PriorityPending = 3,
    PriorityShared = 4,
    PerformanceReview = 5
}
